export const SEARCH_PAGE_SIZE = 10;
export const SEARCH_BASE_PATH = "/workers";

export type SearchCatalogType = "category" | "service";

export type SearchCategoryOption = {
  id: number;
  name: string;
  sortOrder?: number | null;
};

export type SearchServiceOption = {
  id: number;
  name: string;
  categoryName: string;
  sortOrder?: number | null;
};

export type SearchRegionOption = {
  id: number;
  name: string;
  countryCode?: string;
  sortOrder?: number | null;
};

export function slugifyCatalogValue(value: string) {
  return value.trim().toLowerCase().replaceAll("_", "-");
}

export function catalogSlugToKey(value?: string | string[]) {
  const raw = Array.isArray(value) ? value[0] : value;

  return (raw || "").trim().toLowerCase().replaceAll("-", "_");
}

export function toTitleCase(value: string) {
  return value
    .replaceAll("_", " ")
    .replaceAll("-", " ")
    .replace(/\b\p{L}/gu, letter => letter.toUpperCase());
}

export function getWorkersSearchPath(regionKey?: string) {
  if (!regionKey) return SEARCH_BASE_PATH;

  return `${SEARCH_BASE_PATH}/${slugifyCatalogValue(regionKey)}`;
}

export function getCategorySearchPath(categoryKey: string, regionKey?: string) {
  const categoryPath = `${SEARCH_BASE_PATH}/${slugifyCatalogValue(categoryKey)}`;

  if (!regionKey) return categoryPath;

  return `${categoryPath}/${slugifyCatalogValue(regionKey)}`;
}

export function getServiceSearchPath(
  categoryKey: string,
  serviceKey: string,
  regionKey?: string,
) {
  const servicePath = `${SEARCH_BASE_PATH}/${slugifyCatalogValue(
    categoryKey,
  )}/${slugifyCatalogValue(serviceKey)}`;

  if (!regionKey) return servicePath;

  return `${servicePath}/${slugifyCatalogValue(regionKey)}`;
}
